import { render, staticRenderFns } from "./search-by-bags.vue?vue&type=template&id=afcb502e&"
import script from "./search-by-bags.vue?vue&type=script&lang=js&"
export * from "./search-by-bags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports